// extracted by mini-css-extract-plugin
export default {"inputItem":"BVxvPhp","disableFlex":"KLa6rz3","max":"jNUSeWD","inputTitle":"G1Nh83m","inputDesc":"APybs1h","inputInfo":"nZ_T0ct"};